import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "../Tables/Table.css";
import { deleteHL7Node } from "../utilities/HL7utils";

export default function HL7NodeTable(props) {
  const {
    searchInput,
    searchflag,
    setsearchflag,
    sortby,
    hL7Nodes,
    deleteAlert,
    setDeleteAlert,
    handlePage,
    setDeleteID,
    type,
    setEdit,
    setEditModal,
    currentPage,
  } = props;
  const [count, setCount] = useState(1);
  const [configData, setConfigData] = useState([]);
  const [numberOfEntries, setNumberOfEntries] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [currentIdToDelete, setCurrentIdToDelete] = useState(-1);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (searchflag) {
      setCount(1);
      setsearchflag(false);
    }
  }, [searchflag, searchInput, setsearchflag]);

  useEffect(() => {
    if (hL7Nodes && hL7Nodes.items) {
      setConfigData(hL7Nodes.items);
      setTotalData(hL7Nodes.total);
      setTotalPages(Math.ceil(hL7Nodes.total / numberOfEntries));
    }
  }, [hL7Nodes, numberOfEntries]);

  const handleDelete = (id) => {
    setDeleteAlert(true);
    setDeleteID(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    deleteHL7Node(currentIdToDelete);
    setIsDeleteModalOpen(false);
  };

  const handleEdit = (item) => {
    setEdit(item);
    setEditModal(true);
  };

  const handlePageChange = (page) => {
    if (page >= 0 && page < totalPages) {
      setCount(page + 1);
    }
  };

  const renderActions = (item) => (
    <div>
      <i
        className="fa fa-trash"
        onClick={() => handleDelete(item?.id)}
        style={{
          cursor: "pointer",
          marginRight: "1rem",
          fontSize: "1rem",
          color: "white",
        }}
        title="Delete"
      ></i>
      <i
        className="fa fa-pencil"
        onClick={() => handleEdit(item)}
        style={{ cursor: "pointer", fontSize: "1rem", color: "white" }}
        title="Edit"
      ></i>
    </div>
  );

  return (
    <>
      <div>
        <table className="hl7-table styled-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>IP</th>
              <th>Port</th>
              <th>Version</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {configData &&
              configData.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.ip}</td>
                  <td>{item.port}</td>
                  <td>{item.version}</td>
                  <td>{renderActions(item)} </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="pagination">
          <ReactPaginate
            previousLabel="<"
            nextLabel=">"
            breakLabel="..."
            breakClassName="break-me"
            pageCount={totalPages && totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            forcePage={currentPage && currentPage}
            onPageChange={(e) => handlePage(e.selected)}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
            previousLinkClassName="pagination-link"
            nextLinkClassName="pagination-link"
            breakLinkClassName="pagination-link"
            pageLinkClassName="pagination-link"
          />
        </div>
      </div>
    </>
  );
}
